import React, { useState, useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Layout from './components/Layout/Layout';
import Homepage from './pages/Homepage';
import CategoryPage from './pages/CategoryPage';
import ToolPage from './pages/ToolPage';
import NotFound from './pages/NotFound';
import { LanguageProvider } from './context/LanguageContext';

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    if (saved !== null) {
      return JSON.parse(saved);
    }
    return window.innerWidth <= 768;
  });

  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  const router = createBrowserRouter([
    {
      path: '/',
      element: <Layout darkMode={darkMode} toggleDarkMode={toggleDarkMode} />,
      children: [
        { path: '/', element: <Homepage /> },
        { path: '/tools/:category', element: <CategoryPage /> },
        { path: '/tools/:category/:toolName', element: <ToolPage /> },
        { path: '*', element: <NotFound /> },
      ],
    },
  ], {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  });



  return (
    <LanguageProvider>
      <RouterProvider router={router} />
    </LanguageProvider>
  );
}

export default App;
